import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';
import withoutNulls from '../../api/search/withoutNulls';

const VERSION = 'v1';

// Exported for unit testing — the toFirestore transform is exactly the payload
// written to Firestore.
export const bonusRecordTaggingConfigConverter = {
  toFirestore(
    config: BonusRecordTagging.RecordTaggingConfig,
  ): firebase.firestore.DocumentData {
    // Firestore rejects `undefined` field values (the app isn't configured with
    // ignoreUndefinedProperties) and FilterPlate scopes carry optional undefined
    // fields (e.g. a boolean filter's dataset/exists/isExclude). withoutNulls
    // deep-strips them — also covers an undefined columnSizeStrategy. It
    // preserves `false`, so a text "Blanks" filter (keywordsExists === false)
    // round-trips intact rather than being silently dropped on save.
    return withoutNulls({ ...config });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<BonusRecordTagging.RecordTaggingConfig>,
    options: firebase.firestore.SnapshotOptions,
  ): BonusRecordTagging.RecordTaggingConfig {
    return {
      ...snapshot.data(options),
    };
  },
};

const getBonusRecordTaggingConfigRef = ({
  accountId,
  bonusProgramId,
  docId,
}: {
  accountId: string;
  bonusProgramId: string;
  // The exclusion config doc id — see getExclusionConfigDocId.
  docId: string;
}) => {
  return firebase
    .firestore()
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_EXCLUSION_GRIDS_CONFIG_COLLECTION)
    .doc(bonusProgramId)
    .collection(VERSION)
    .doc(docId)
    .withConverter(bonusRecordTaggingConfigConverter);
};

export default getBonusRecordTaggingConfigRef;
